import styled from "styled-components";

export const EyeIconWrap = styled.div`
  border-color: #58a3a4;
  justify-self: end;
  .eye-icon-btn {
    position: relative;
    overflow: hidden;
  }
  .eye {
    height: 26px;
    padding: 0 7px;
    background: #58a3a4;
  }
  .ripple-effect {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(88, 163, 164, 0.2);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: width 0.5s ease-out, height 0.5s ease-out;
    z-index: 0;
  }

  .eye-icon-btn:hover .ripple-effect {
    width: 300%;
    height: 300%;
  }
  strong {
    padding: 0 4px;
    color: #58a3a4;
  }
`;
